import { FEATURE_PDP_LABOR_DAY_SALE } from 'constants/features';
import { cn } from 'helpers/classnames';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import useMartyContext from 'hooks/useMartyContext';

interface ZPromoProps {
  className?: string;
}

export const ZPromo = ({ className }: ZPromoProps) => {
  // We are using the FEATURE_PDP_LABOR_DAY_SALE feature flag to check if the ZPromo is enabled

  const { isEnrolled: isLaborDaySaleEnabled } = useIsEnrolledInVariant({ featureFlag: FEATURE_PDP_LABOR_DAY_SALE, isZapposOnly: false });
  const {
    marketplace: { is6pm }
  } = useMartyContext();

  if (!isLaborDaySaleEnabled || is6pm) {
    return null;
  }

  return (
    <p data-test-id="zPromo" className={cn('w-fit rounded-sm bg-green-50 p-1 text-sm text-gray-800', className)} role="alert">
      Use code <span className="font-bold">WIN20</span> at checkout
    </p>
  );
};
